module.exports = __webpack_public_path__ + "img/profile.8b91c69.svg";